import { Component } from '@angular/core';

@Component({
    selector: 'error-notauthorized',
    templateUrl: './notauthorized.component.html',
    styles: [],
    standalone: false
})
export class NotAuthorizedComponent {
    constructor() { }
}